import { TipsHistory } from '@/services/PaymentsServiceV2';
import { DATE_FORMAT } from '@/lib/constants';

const NOT_REPORTED = 'NotReported';

/**
 * Stable identity of a daily-settlement row: the backend groups journals by location and
 * date, and resyncs the same pair, so that pair is the row. `posJournalId` is only the
 * first of possibly several journals behind the row, and the list's previous
 * `JSON.stringify(tip) + index` key changes whenever the figures or the sort order do —
 * neither survives the refetch that a resync triggers.
 */
export const tipsRowKey = (tip: TipsHistory) =>
    `${tip.locationId}::${tip.date?.format(DATE_FORMAT.SERVER_DATE)}`;

/**
 * A row can be resynced only when nothing behind it has reached payroll.
 *
 * The row's own `reportingStatus` cannot answer this: the backend collapses the group to
 * NotReported as soon as *any* single journal is unreported, so a day holding one reported
 * and one unreported journal looks eligible through that field while a resync would delete
 * data payroll has already been told about. Only the per-journal statuses are conclusive.
 */
export const isResyncEligible = (tip: TipsHistory) => {
    const journals = tip.posJournalAmounts;

    if (journals && journals.length > 0) {
        return journals.every((j) => j.reportingStatus === NOT_REPORTED);
    }

    // Older rows the API serves without the per-journal breakdown fall back to the
    // aggregate; the backend re-checks every journal before deleting anything either way.
    return tip.reportingStatus === NOT_REPORTED;
};
